/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tag/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Employee from './Employee/index'
import ExternalProfessional from './ExternalProfessional/index'
import No from 'DesignSystem/VideoRecorderNative/No/index'
import Patient from './Patient/index'
import Payer from './Payer/index'
import React from 'react'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function Tag({
  children,
  viewPath = "/App/ChooseUser/Users/Content/User/Tag"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || ''
let userValueData = fromData.useDataFormat({ viewPath,
context: 'user',
format: fromHelpers.getView,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: userValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={[].includes(flowValue)}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Payer'}>
<Payer
  viewPath={`${viewPath}/Payer`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Patient'}>
<Patient
  viewPath={`${viewPath}/Patient`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Employee'}>
<Employee
  viewPath={`${viewPath}/Employee`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'ExternalProfessional'}>
<ExternalProfessional
  viewPath={`${viewPath}/ExternalProfessional`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}